import { Editor } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import constants from '@/utilities/constants';
import getFileIdFromUrl from '@/utilities/getFileIdFromUrl';

type DoubleClickOptions = {
  editor: Editor;
};

export function doubleClick(options: DoubleClickOptions): Plugin {
  return new Plugin({
    key: new PluginKey('doubleClick'),
    props: {
      handleDoubleClickOn: (view, pos, node, nodePos, event) => {
        if (node.type.name === constants.stImage) {
          const id = getFileIdFromUrl(node.attrs.imgsrc);
          options.editor.commands.displayFullScreenImage(id);
          event.preventDefault();
          event.stopPropagation();
        }
      },
    },
  });
}
